import { Button } from '@hqo/ui-atoms';
import { cn } from '@hqo/react-hooks';

interface VisitorModeButtonProps {
  isActive: boolean;
  onClick: () => void;
  label: string;
  disabled?: boolean;
}

export const VisitorModeButton = ({ isActive, onClick, label, disabled }: VisitorModeButtonProps): JSX.Element => (
  <Button
    onClick={onClick}
    disabled={disabled}
    aria-pressed={isActive}
    variant={isActive ? 'default' : 'outline'}
    className={cn(
      'cursor-pointer px-5 py-2 font-semibold rounded-xl transition-all h-12',
      isActive
        ? 'bg-primary text-primary-foreground hover:bg-primary/90'
        : 'bg-background text-foreground hover:bg-accent hover:text-accent-foreground border border-border',
      disabled && 'cursor-not-allowed opacity-50',
    )}
  >
    {label}
  </Button>
);
